// extracted by mini-css-extract-plugin
export default {"logout-container":"Logout_logout-container__hWs+E","logout-text":"Logout_logout-text__RC127"};